;(function() {
  'use strict'

  notificationsService.$inject = ["$q", "$rootScope", "$state", "$timeout", "AUTH_EVENTS", "utilsService", "notificationsResource", "notifyService", "statsService", "pollingService"];
  angular
    .module('core.services')
    .service('notificationsService', notificationsService)

  // --------------------

  /* @ngInject */
  function notificationsService(
    $q,
    $rootScope,
    $state,
    $timeout,
    AUTH_EVENTS,
    utilsService,
    notificationsResource,
    notifyService,
    statsService,
    pollingService
  ) {
    var isRunning
    var timer
    var currentListId
    var prevIds
    var icons = {
      survey: 'gi gi-survey blue',
      reward: 'gi gi-offers green',
      coupon: 'gi gi-offers green',
      post: 'gi gi-communicate blue',
      review: 'gi gi-review blue',
      idea: 'gi gi-idea blue',
      announcement: 'gi gi-notification orange',
      conversation: 'gi gi-communicate orange',
    }
    var routeSignatures = [
      {
        // - /main/post/:id
        signature: '/main/post/',
        stateName: 'app.portal.message',
        identifier: 'id',
      },
      {
        // - /main/surveys
        signature: '/main/surveys',
        stateName: 'app.portal.surveys',
      },
      {
        // - /main/survey/:id
        signature: '/main/survey/',
        stateName: 'app.survey',
        identifier: 'id',
      },
      {
        // - /main/element/:id
        signature: '/main/element/',
        stateName: 'app.portal.element',
        identifier: 'id',
      },
      {
        // - /main/rewards
        signature: '/main/rewards',
        stateName: 'app.portal.rewards',
      },
      {
        // - /main/reward/:id
        // go to list for now
        signature: '/main/reward/',
        stateName: 'app.portal.rewards',
      },
    ]

    /**
     * start notifications polling on login success
     */
    $rootScope.$on(AUTH_EVENTS.loginSuccess, function() {
      start()
    })

    /**
     * stop notifications polling on logout success
     */
    $rootScope.$on(AUTH_EVENTS.logoutSuccess, function() {
      stop()
    })

    $rootScope.$on('survey:responded', check)

    return {
      start: start,
      stop: stop,
      check: check,
      list: list,
      clear: clear,
    }

    function start() {
      if (isRunning) {
        return
      }
      isRunning = true
      check()
    }

    function stop() {
      isRunning = false
      killTimer()
      prevIds = null
    }

    function check(delay) {
      killTimer()
      if (!isRunning) {
        return
      }
      timer = $timeout(function() {
        if (!pollingService.isEnabled()) {
          return check(true)
        }

        list().then(
          function(notifications) {
            if (!isRunning) {
              return
            }
            notifyOfNew(notifications)
            check(true)
          },
          function() {
            check(true)
          }
        )
      }, delay ? 10000 : 0)
    }

    function notifyOfNew(notifications) {
      var nextIds = _.map(notifications, 'id')
      var newIds = _.difference(nextIds, prevIds || [])
      if (!prevIds) {
        prevIds = nextIds
      } else {
        _.each(newIds, function(id) {
          var n = _.find(notifications, { id: id })
          if (!n) {
            return
          }
          notifyService.show(
            n.title,
            {
              body: n.subTitle,
              tag: n.type,
            },
            function() {
              $state.go(n.extras.state.name, n.extras.state.params, {
                reload: true,
              })
            }
          )
        })
        prevIds = nextIds
      }
    }

    function killTimer() {
      if (timer) {
        $timeout.cancel(timer)
      }
    }

    function list() {
      return $q(function(resolve, reject) {
        notificationsResource
          .list()
          .success(function(res, data) {
            currentListId = data[0].id
            data = data[0].notifications // remove depth
            order(data)
            addExtras(data)
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function order(notifications) {
      var clone = _.clone(notifications)
      notifications.splice(0, notifications.length)
      clone = _.sortBy(clone, function(item) {
        return moment(item.createdAt).unix() || 0
      }).reverse()
      notifications.push.apply(notifications, clone)
    }

    function addExtras(notifications) {
      _.each(notifications, function(item) {
        item.extras = {}
        item.extras.icon = icons[item.type] || 'gi gi-notification'
        item.extras.state = stateFromRoute(item.route)
      })
    }

    function stateFromRoute(route) {
      var action = _.find(routeSignatures, function(action) {
        return route.indexOf(action.signature) === 0
      })
      if (action) {
        var state = {}
        state.name = action.stateName
        if (action.identifier) {
          var identifierValue = route.split(action.signature)[1]
          state.params = {}
          state.params[action.identifier] = identifierValue
        }
        return state
      }
    }

    function clear() {
      return $q(function(resolve, reject) {
        if (!currentListId) {
          return resolve()
        }
        var data = {
          id: currentListId,
          isRead: true,
        }
        notificationsResource
          .update(data)
          .success(function() {
            statsService.refresh()
            resolve()
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }
  }
})()
